import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

import {
  requestEmailChange,
  signOut
} from '../../actions';

class ChangeEmailModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stage: 1,
      newEmail: '',
      otp: '',
      password: '',
      pristine: true,
    };
    this.confirmSubmit = this.confirmSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ stage: 2 });
  }

  confirmSubmit(event) {
    // event.preventDefault();
    const { dispatch, history } = this.props;
    const { newEmail, otp, password } = this.state;

    const data = {
      otp,
      password,
      newEmail
    }

    this.setState({ pristine: true });
    dispatch(requestEmailChange(data)).then((res) => {
      if (res.type === 'REQUEST_EMAIL_CHANGE_SUCCESS') {
        this.setState({ pristine: true, stage: 3 });
      }
      if (res.type === 'REQUEST_EMAIL_CHANGE_FAIL') {
        this.setState({ pristine: true, stage: 1 });
      }
    });
  }

  render() {
    const { user } = this.props;
    const { newEmail, password, otp, pristine, stage } = this.state;

    const complete = newEmail && password;

    if (stage === 3) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Change Your Email Address</div>
              <div className="modal-subheading">
                Email change successfully requested.
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>Your have successfully requested an email change to the following address:</p>
              <h3>{newEmail}</h3>
              <p>We have just sent additional instructions, along with a confirmation link, to your existing email address.</p>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Close
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (stage === 2) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Change Your Email Address</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>Are you sure you want to change your email address to:</p>
              <h3>{newEmail}</h3>
              <p>You will be asked to confirm this change via email.</p>
              <p>For security purposes you will be unable to withdraw for 48 hours after changing your email.</p>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              <button className="vlt-button" type="button" disabled={!complete || pristine} onClick={() => this.confirmSubmit()}>
                <span>
                  Confirm
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Change Your Email Address</div>
            <p>
              Enter your new email address and password information below.
            </p>
            <p>
              You will be unable to withdraw for 48 hours after changing your email address.
            </p>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <form onSubmit={this.handleSubmit} id="form1">
              <div className="input-wrapper">
                <input id="newEmail" className="modal-input" type="email" name="New Email" placeholder="New Email" value={newEmail} onChange={this.handleChange} autoFocus autoComplete="new-email" />
              </div>
              <div className="input-wrapper">
                <input id="password" className="modal-input" type="password" name="Password" placeholder="Password" value={password} onChange={this.handleChange} />
              </div>
              <div className="input-wrapper">
                <input id="otp" className="modal-input" type="text" name="2FA" placeholder="Two Factor Authentication (if enabled)" value={otp} onChange={this.handleChange} autoComplete="new-otp" />
              </div>
            </form>
          </div>
          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
              <span>
                Cancel
              </span>
            </button>
            <button className="vlt-button" type="submit" form="form1" disabled={!complete || pristine}>
              <span>
                Submit
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  resetCode: state.user.resetCode,
});

export default connect(mapStateToProps)(ChangeEmailModal);
